import { FormBase } from 'core/components';
import { GeneralStepEditForm, DimensionsStepEditForm, VirtualSKUStepEditForm } from 'modules/product/wizard/forms';
import _ from 'lodash';

export default class ProductEditForm extends FormBase {
	formFields = null;
	constructor(hooks) {
		super(hooks);
		this.formFields = this.getForm().fields;
	}

	getForm() {
		const generalStep = GeneralStepEditForm(),
			dimensionsStep = DimensionsStepEditForm(),
			virtualSKUStep = VirtualSKUStepEditForm();
		const fields = _.concat(generalStep.fields, dimensionsStep.fields, virtualSKUStep.fields);
		//merge does not work on arrays
		delete generalStep.fields;
		delete dimensionsStep.fields;
		delete virtualSKUStep.fields;
		const form = _.merge(generalStep, dimensionsStep, virtualSKUStep);
		this.formFields = fields;
		form.fields = fields;
		return form;
	}

	options() {
		return { validateOnBlur: false, showErrorsOnReset: false, validateOnChange: true };
	}

	setup() {
		return {
			...this.getForm(),
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/ProductEditForm.js